import {Component} from '@angular/core'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {MatError, MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatInput} from '@angular/material/input'
import {PhoneValidatorDirective} from '../../directives/phone-validator.directive'
import {InputBaseComponent} from '../0-base/input-base.component'

@Component({
  selector: 'spb-mobile',
  imports: [
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    FormsModule,
    PhoneValidatorDirective,
    MatError,
    MatIcon,
    MatSuffix
  ],
  templateUrl: './mobile.component.html',
  styleUrl: './mobile.component.scss',
  providers: [{provide: InputBaseComponent, useExisting: MobileComponent}]
})
export class MobileComponent extends InputBaseComponent<string> {
  protected override prop = 'mobile'

}
